var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "HKLModal",
        {
          ref: "addFoldersModalRef",
          staticClass: "add-folders",
          attrs: {
            size: "small",
            title: _vm.$t("tenantProjects.greenFitOut.addFoldersTitle"),
            closable: true,
            okBtnAction: "add",
            afterClose: _vm.resetData,
            okBtnDisabled: !_vm.pendToAddFolders.length,
          },
          on: { onOkClick: _vm.openAddReceiverModal },
        },
        [
          _c("div", { staticClass: "green-fit-out-folders" }, [
            _vm._v(
              "\n      " +
                _vm._s(
                  _vm.$t("tenantProjects.greenFitOut.greenFitOutFolders")
                ) +
                "\n    "
            ),
          ]),
          _vm._v(" "),
          _vm._l(_vm.publishedFolders, function (section, sectionIndex) {
            return [
              _c(
                "HKLCollapse",
                { key: sectionIndex, staticClass: "add-folders_section" },
                [
                  _c("div", { attrs: { slot: "title" }, slot: "title" }, [
                    _c("label", { staticClass: "section-checkbox" }, [
                      _c("div", [
                        _vm._v(
                          _vm._s(section.displayOrder + ". " + section.value)
                        ),
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        attrs: {
                          type: "checkbox",
                          disabled: _vm.isDisabledSection(section),
                        },
                        domProps: { checked: _vm.getSectionStatus(section) },
                        on: {
                          change: function (e) {
                            return _vm.onCheckAllChange(
                              section,
                              e.target.checked
                            )
                          },
                        },
                      }),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { attrs: { slot: "content" }, slot: "content" },
                    [
                      _vm._l(
                        section.sectionContent,
                        function (folder, folderIndex) {
                          return [
                            _c(
                              "div",
                              {
                                key: folder.value,
                                staticClass: "line-checkout-outer",
                              },
                              [
                                _c(
                                  "label",
                                  {
                                    key: folderIndex,
                                    staticClass: "line-checkbox",
                                  },
                                  [
                                    _c("div", [
                                      _vm._v(
                                        _vm._s(
                                          folder.displayOrder +
                                            ". " +
                                            folder.value
                                        )
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("input", {
                                      attrs: {
                                        type: "checkbox",
                                        disabled: _vm.isDisabledFolder(
                                          section,
                                          folder
                                        ),
                                      },
                                      domProps: {
                                        checked: _vm.getFolderStatus(
                                          section,
                                          folder
                                        ),
                                      },
                                      on: {
                                        change: function (e) {
                                          return _vm.onChange(
                                            section,
                                            folder,
                                            e.target.checked
                                          )
                                        },
                                      },
                                    }),
                                  ]
                                ),
                              ]
                            ),
                          ]
                        }
                      ),
                    ],
                    2
                  ),
                ]
              ),
            ]
          }),
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "HKLModal",
        {
          ref: "addReceiversModalRef",
          staticClass: "add-recievers",
          attrs: {
            size: "small",
            title: _vm.$t("tenantProjects.greenFitOut.addReceiversTitleHint"),
            closable: true,
          },
          scopedSlots: _vm._u([
            {
              key: "footer",
              fn: function () {
                return [
                  _c("HKLButton", {
                    staticClass: "mg-right",
                    attrs: { color: "darkblue", action: "goback" },
                    on: { click: _vm.goBack },
                  }),
                  _vm._v(" "),
                  _c("HKLButton", {
                    attrs: { color: "orange", action: "yesSendNow" },
                    on: { click: _vm.addFolders },
                  }),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _c(
            "HKLForm",
            { ref: "form" },
            [
              _c("EmailGroupEditor", {
                model: {
                  value: _vm.initialEmails,
                  callback: function ($$v) {
                    _vm.initialEmails = $$v
                  },
                  expression: "initialEmails",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "end-hint" }, [
            _vm._v(
              "\n      " +
                _vm._s(
                  _vm.$t("tenantProjects.greenFitOut.addReceiversEndHint")
                ) +
                "\n    "
            ),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }